<template>
    <div class="w-full mb-10">
        <div
            class="w-full flex flex-row items-center xs:justify-between flex-wrap xs:flex-nowrap justify-end gap-3 xs:gap-0"
        >
            <div
                class="note-card flex flex-row items-start justify-start  w-full"
            >
                <div
                    class="rounded-md mr-3 text-center py-1 w-18 text-white font-semibold bg-primary-light hover:bg-primary transition-colors cursor-pointer"
                    @click="$emit('timeClick')"
                >
                    {{ isPdf ? note.seconds : computedTime }}
                </div>
                <div class="w-full" style="width: calc(100% - 84px);">
                    <div
                        class="w-full font-semibold overflow-hidden whitespace-nowrap overflow-ellipsis text-primary text-base mb-2"
                    >
                        {{ note.customer.full_name }}
                    </div>
                    <div
                        class="w-full overflow-hidden whitespace-nowrap overflow-ellipsis text-black text-base "
                    >
                        {{ computedDate }}
                    </div>
                </div>
            </div>
            <div class="flex flex-row items-center justify-end">
                <icon-container
                    class="bg-black bg-opacity-0 hover:bg-opacity-10 transition-all mr-2"
                    :icon="'EditIcon'"
                    iconFill="fill-primary"
                    @click="$emit('edit')"
                />
                <icon-container
                    class="bg-black bg-opacity-0 hover:bg-opacity-10 transition-all"
                    :icon="'TrashIcon'"
                    iconFill="fill-primary"
                    :id="'delete-note-' + note.id"
                    @click="$emit('delete')"
                />
            </div>
        </div>
        <div
            class="w-full px-3 py-4 rounded-md bg-white-dark text-base whitespace-pre-line text-black mt-4"
        >
            {{ note.text }}
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { dateToLocalDateTime } from "../../../../common/formatDates";
import IconContainer from "../../../../components/helper/IconContainer.vue";
export default defineComponent({
    components: { IconContainer },
    name: "Notes",
    props: {
        note: { required: true },
        isPdf: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["edit", "delete", "timeClick"],
    setup(props) {
        /**
         *  State
         */
        const state = reactive({});
        /**
         *  Functions
         */
        function convertTime(time) {
            var minutes = Math.floor(time / 60);
            var seconds = Math.floor(time % 60);
            var hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            if (hours != 0) {
                if (minutes <= 10) {
                    minutes = "0" + minutes;
                }
                return hours + ":" + minutes + ":" + seconds;
            } else {
                return minutes + ":" + seconds;
            }
        }
        const computedTime = computed(() => {
            const time = convertTime(props.note.seconds);

            return time;
        });
        const computedDate = computed(() => {
            const time = dateToLocalDateTime(props.note.created_at);

            return time;
        });
        return {
            state,
            computedTime,
            computedDate,
        };
    },
});
</script>
<style lang="scss">
.note-card {
    width: 100%;
    @screen xs {
        width: calc(100% - 100px);
    }
}
</style>
